import { ContactInfo } from '../types';

export const contactInfo: ContactInfo = {
  email: 'sierk@fwp.one',
  linkedin: 'https://www.linkedin.com/in/FWP-one/',
  github: 'https://github.com/sierkvdv',
  instagram: 'https://www.instagram.com/sierkvdv?igsh=MXg5ZmhoMm9hbG96Mg%3D%3D&utm_source=qr',
  bloodline: 'https://bloodlineproject.vercel.app'
};
// Force Vercel rebuild for animations 